import { PreparingObject } from "../preparing_object";
import { DirectionalLight, Vector3 } from "three";
import { DebugDraw } from "../../renderer/debug";
const SCRATCH = new Vector3();
export class CameraAwareSunLight extends PreparingObject {
    constructor() {
        super();
        this.direction = new Vector3();
        this.light = new DirectionalLight(0xffffffff, 0.8);
        this.add(this.light);
        this.add(this.light.target);
    }
    prepare(renderer, camera, frameData) {
        super.prepare(renderer, camera, frameData);
        camera.matrixWorld.extractBasis(SCRATCH, SCRATCH, this.direction);
        const target = this.direction.negate().multiplyScalar(1000).add(camera.position);
        this.light.position.set(camera.position.x, camera.position.y, camera.position.z);
        this.light.target.position.set(target.x, target.y, target.z);
        if (frameData.options.debug.sunLightDirection) {
            DebugDraw.addLine(this.light.position, this.light.target.position);
        }
    }
}
